import { createTheme, type MantineColorsTuple } from '@mantine/core';

// The app's own colours (app/src/theme/tokens.ts): The Success Time red, ink for text and the sidebar,
// amber for "waiting", green for "live".
const brand: MantineColorsTuple = ['#fff0f1', '#ffdadd', '#f5b0b6', '#ec838c', '#e45c68', '#df4352', '#d0021b', '#b50018', '#a4020f', '#8c000b'];
const ink: MantineColorsTuple = ['#f3f4f8', '#e4e6ee', '#c5c9d8', '#a3a9c1', '#868dad', '#737ba1', '#69729c', '#575f88', '#2a3050', '#161a2e'];

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,
  colors: { brand, ink },
  fontFamily: 'Mukta, "Noto Sans Devanagari", system-ui, -apple-system, "Segoe UI", sans-serif',
  headings: { fontFamily: 'Mukta, "Noto Sans Devanagari", system-ui, sans-serif', fontWeight: '700' },
  defaultRadius: 'sm',
  cursorType: 'pointer',
  components: {
    Button: { defaultProps: { fw: 600 } },
    Badge: { defaultProps: { variant: 'light', radius: 'sm' } },
  },
});

/** Status → colour, shared by every list (draft grey, waiting amber, live green, stopped red). */
export const STATUS_COLOR: Record<string, string> = {
  draft: 'gray',
  in_review: 'yellow',
  pending: 'yellow',
  scheduled: 'blue',
  uploading: 'gray',
  processing: 'yellow',
  ready: 'teal',
  published: 'green',
  active: 'green',
  confirmed: 'green',
  sent: 'green',
  actioned: 'green',
  new: 'brand',
  sending: 'blue',
  paused: 'orange',
  unpublished: 'orange',
  invited: 'blue',
  expired: 'gray',
  ended: 'gray',
  closed: 'gray',
  archived: 'gray',
  cancelled: 'gray',
  unsubscribed: 'gray',
  disabled: 'red',
  failed: 'red',
};
